<template>
  <qx-card title="列表">
    <QrcodeDialog ref="qrcodeDialog" />
    <LogRightDialog
      ref="logRightDialog"
      busiCode="400001"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()" v-if="false">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'productName'" @click="toDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-if="scope.column.property === 'serviceName'" @click="toServiceDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-if="scope.column.property === 'price'">
                <span v-if="scope.row.localeBalanceState !== '' && scope.row.localeBalanceState !== null && scope.row.localeBalanceState === 1">现场价</span>
                <span v-if="scope.row.isBillAbility !== 1 && scope.row.floatBalance !== '' && scope.row.floatBalance !== null">{{scope.row.floatBalance}}%</span>
                <span v-if="scope.row.isBillAbility !== 1 && scope.row.fixedBalance !== '' && scope.row.fixedBalance !== null">{{scope.row.fixedBalance / 100}}元/升</span>
                <span v-if="scope.row.isBillAbility === 1 && scope.row.floatBalanceBill !== '' && scope.row.floatBalanceBill !== null">{{scope.row.floatBalanceBill}}%</span>
                <span v-if="scope.row.isBillAbility === 1 && scope.row.fixedBalanceBill !== '' && scope.row.fixedBalanceBill !== null">{{scope.row.fixedBalanceBill / 100}}元/升</span>
              </section>
              <section
                v-if="scope.column.property !== 'productName' && scope.column.property !== 'serviceName' && scope.column.property !== 'price'"
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="" v-if="scope.row.serviceType !== 100 && scope.row.serviceType !== 3">
                  <span class="primary cur" @click="toTransRecord(scope.row)">交易</span>
                </qx-permpisions>
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.relId)">日志</span>
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  siteRecordList,
} from 'api/service';
import LogRightDialog from 'components/logRightDialog';
import QrcodeDialog from '../qrcodeDialog';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    QrcodeDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'productName',
            label: '产品名称',
          },
          {
            prop: 'serviceCall',
            label: '服务电话',
          },
          {
            prop: 'address',
            label: '服务地址',
          },
          {
            prop: 'serviceName',
            label: '归属服务商',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: siteRecordList,
    showQrCode (item) {
      this.$refs.qrcodeDialog.show(item);
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    toEdit (item = {}) {
      let serviceUserId = '';
      if (item.serviceUserId) {
        serviceUserId = item.serviceUserId;
      } else if (this.searchBoxData.serviceUserId) {
        serviceUserId = this.searchBoxData.serviceUserId;
      }
      this.jump({
        label: (item.productId ? '修改' : '新增') + '后服产品',
        url: `/manage/service/site/self/edit?serviceUserId=${serviceUserId}&serviceType=${item.serviceType || ''}${item.productId ? '&id=' + item.productId : ''}`,
        full: true,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核后服产品' : '后服产品详情',
        url: `/manage/service/site/self/detail?serviceUserId=${item.serviceUserId}&serviceType=${item.serviceType}&id=${item.productId}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    toServiceDetail (item) {
      this.jump({
        label: '服务商详情',
        url: `/manage/service/merchant/manage/detail?id=${item.serviceUserId}`,
        full: true,
      });
    },
    toTransRecord (item) {
      this.jump({
        label: '交易记录',
        url: `/manage/service/site/transRecord?productId=${item.productId}&serviceType=${item.serviceType}&productName=${encodeURIComponent(item.productName)}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
